export default __webpack_public_path__ + "static/data@2x-f0e0c21f8ad51002ded98b782277b095.png";